// Batch 5 — equipment on events: the double-booking warning and "Lost or
// broken" on Send equipment back. Plain words for the manager and the chef.

export const EQ = {
  clashTitle: 'Not enough equipment that day',
  clashHelp: 'You can still save. Hire or borrow the rest, or change the amounts.',
  /** "Chafing dishes: 12 asked here, 10 already booked for Sat 31 Oct — you own 18" */
  clashLine: (name: string, here: string, elsewhere: string | null, day: string, owned: string) =>
    elsewhere
      ? `${name}: ${here} asked here, ${elsewhere} already booked for ${day} — you own ${owned}`
      : `${name}: ${here} asked here for ${day} — you own ${owned}`,
  bookedOn: (refs: string) => `Booked on ${refs}`,

  returnTitle: 'Send equipment back',
  returnHelp: 'Say how many are coming back to the store. Anything lost or broken is written off with a manager PIN, so it stops showing as still out.',
  stillOut: (n: string) => `Still out: ${n}`,
  onWayBack: (n: string) => `On its way back: ${n}`,
  missingOnWayBack: (n: string) => `Missing on the way back (store is checking): ${n}`,
  comingBack: 'Coming back',
  lostOrBroken: 'Lost or broken',
  kinds: { broken: 'Broken', lost: 'Lost' } as const,
  whatHappened: 'What happened? (optional)',
  pin: 'Manager PIN',
  tooMuch: 'Coming back and lost or broken together are more than is still out.',
  nothing: 'Enter how many are coming back, or how many were lost or broken.',
  submitBack: 'Send back to store',
  submitWriteOff: 'Write off',
  submitBoth: 'Send back and write off',
  saving: 'Saving…',
  cancel: 'Not now',
  done: 'Equipment updated',
  lostColumn: 'Lost or broken',
  allOnWayBack: 'The rest is on its way back to the store.',
}
